import React from "react";
import "./Pincode_section.css";
import Black_Btn from "../../Common-Component/Common_Btn/Black_Btn/Black_Btn";
import { Form } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useForm } from "react-hook-form";
import { pincodeCheck } from "../../../features/products/productsSlice";
import classNames from "classnames";
function Pincode_section({product,setPincode}) {
  const {
    control,
    register,
    handleSubmit,
    getValues,
    setValue,
    setError,
    clearErrors,
    formState: { errors },
    reset,
    trigger,
  } = useForm();
  const dispatch = useDispatch();
  const onSubmit = async (data) => {
    // if()
    data.product_id=product.id;
    const res = await dispatch(pincodeCheck(data));
    if (res?.payload?.errors) {
      setError("pincode", {
        type: "manual",
        message: res.payload?.errors,
      });
    } else {
      setPincode(data?.pincode)
      // setshowUploadModal(true);
    }

    // if (res.meta?.requestStatus === "fulfilled") {

    //   if(res.payload?.errors){ setError("pincode", {
    //     type: "manual",
    //     message: res.payload?.errors,
    //   });

    //   }
    // } else if (res.meta?.requestStatus === "rejected") {

    // setError("pincode", {
    //   type: "manual",
    //   message: res.payload?.errors,
    // });

    // }
  };
  return (
    <>
      <section className="Pincode_section">
        <div className="heading_holder">
          <h6>Pincode</h6>
        </div>
        <Form onSubmit={handleSubmit(onSubmit)}>
          {errors?.pincode && (
            <sup className="text-danger">{errors?.pincode?.message}</sup>
          )}
          <div className="field_btn_holder">
            <Form.Control
              type="text"
              name="pincode"
              placeholder="Enter Pincode"
              {...register("pincode", {
                required: "Pincode is required",
              })}
              className={classNames("", {
                "is-valid": getValues("pincode"),
              })}
            />

            <Black_Btn btnText={"Save"} type={"submit"} />
          </div>
        </Form>
      </section>
    </>
  );
}

export default Pincode_section;
